import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import store from '../src/store';
import { setUser, setAccessToken } from '../src/store';
import { navigator } from 'lit-element-router';
import { SldsBaseElement } from '../components/slds-base-element.js';
import authManager from '../src/authManager';
import { fetchProfileData } from '../src/apiActions';
import { addNotification } from '../src/store';
@customElement('login-view')

class LoginView extends connect(store)(navigator(SldsBaseElement)) {
  @property({type: Object}) errorMsg = null;
  @property({type: String}) loginDialog = 'login'; //login/recaptcha/accountType/signup/authenticated
  @property({type: String}) smsSentToPhoneNum = '';
  @property({type: Boolean}) enrollMfaButtonDisabled = false;
  @property({type: String}) smsVerificationCode = '';
  @property({type: Boolean}) smsVerificationCodeDisabled = false;
  @property({type: Object}) user = null;
  @property({type: Boolean}) signupDisabled = false;
  @property({type: Boolean}) loginDisabled = true;

  stateChanged(state) {
    if (state.user) {
      this.user = state.user;
      this.loginDialog = 'authenticated';
    }
    else if (!(this.loginDialog === 'signup')) {
      this.user = null;
      this.loginDialog = 'login';
    }
  }

  connectedCallback() {
    super.connectedCallback()
  }

  constructor() {
    super();
  }

  clearError() {
    this.errorMsg = null;
  }

  handleErrors(error) {
    var prettyCode = null;
    console.error(error);
    if (error.code) {
      prettyCode = error.code.split("/").join("-");
    }
    if (error.code === "auth/account-exists-with-different-credential") {
      // The pending Google credential.
      let pendingCred = error.credential;

      // Step 3: Save the pending credential in temporary storage,

      // Step 4: Let the user know that they already have an account
      // but with a different provider, and let them choose another
      // sign-in method.
      debugger;
    }
    if (error.code === "auth/cancelled-popup-request" || error.code === "auth/popup-closed-by-user") {
      this.errorMsg = {msg: "SSO Popup was closed!", code: prettyCode};
    }
    if (error.code === "auth/invalid-verification-code") {
      this.errorMsg = {msg: "Invalid verification code provided!", code: prettyCode};
    }
    else if (error.message) {
      this.errorMsg = {msg: error.message, code: prettyCode};
    }
    else
    {
      console.error(error);
    }
  }

  handleSuccess(result) {
    const user = result.user;
    const reloadUserInfo = user.reloadUserInfo;
    const token = user.accessToken;

    store.dispatch(setAccessToken(token));
    store.dispatch(fetchProfileData());
    // store.dispatch(setUser(reloadUserInfo));
    this.navigate("/");
  }

  updateEmail(e) {
    if (e.target.value.length > 0) {
      this.loginDisabled = false;
    }
    else {
      this.loginDisabled = true;
    }
  }

  updatePassword(e) {
    if (e.target.value.length > 0) {
      this.loginDisabled = false;
    }
    else {
      this.loginDisabled = true;
    }
  }

  async loginEmail(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    this.errorMsg = null;
    if (!(this.loginDialog === 'signup')) {
      this.loginDialog = 'signup';
    }
  }

  async loginEmailForm(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    this.errorMsg = null;
    const email = e.target.elements['email'].value;
    const password = e.target.elements['password'].value;
    const auth = authManager.getAuth();
    const signInWithEmailAndPassword = authManager.signInWithEmailAndPassword;
    var userCredential = null;
    try {
      this.loginDisabled = true;
      userCredential = await signInWithEmailAndPassword(auth, email, password);
      this.loginDisabled = false;
    }
    catch (error) {
      this.loginDisabled = false;
      switch (error.code) {
        case 'auth/invalid-credential':
          this.errorMsg = {msg: "Invalid email or password!", code: null};
          break;
        case 'auth/invalid-email':
          this.errorMsg = {msg: "Invalid email!", code: null};
          break;
        default:
          store.dispatch(addNotification({
            type: 'error',
            content: {
              heading: 'Login failed',
              message: error.message
            }
          }));
      }
    }
    if (userCredential) {
      // store.dispatch(setUser(userCredential.user));
      const token = userCredential.user.accessToken;
      store.dispatch(setAccessToken(token));
      store.dispatch(fetchProfileData());
      this.navigate("/");
    }
  }

  async signupEmail(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    this.errorMsg = null;
    if (!(this.loginDialog === 'signup')) {
      this.loginDialog = 'signup';
    }
    else {
      // Check that passwords match
      const password = e.target.elements['signup-password'].value;
      const confirmPassword = e.target.elements['confirm-password'].value;
      if (password !== confirmPassword) {
        this.errorMsg = {msg: "Passwords do not match!", code: null, type: 'password-mismatch'};
        return null;
      }
      this.signupDisabled = true;
      const auth = authManager.getAuth();
      // Get the email and password from the form
      const email = e.target.elements['signup-email'].value;
      const displayName = e.target.elements['display-name'].value;
      const createUserWithEmailAndPassword = authManager.createUserWithEmailAndPassword;
      var userCredential = null;
      try {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);

        const userEntity = userCredential.user;
        // Get user ID
        const userId = userCredential.user.uid;

        // Update the displayName (or photoURL) for the user
        await authManager.updateProfile(userEntity, {
          displayName: displayName, // Set the user's display name
        });

        // Send email verification
        await authManager.sendEmailVerification(userEntity);

        console.log("User signed up and verification email sent:", userEntity);
        store.dispatch(addNotification({
          type: 'success',
          content: {
            heading: 'Signup successful',
            message: 'Please check your email for verification.'
          }
        }));
        this.loginDialog = 'login';
      }
      catch (error) {
        this.signupDisabled = false;
        console.error(error);

        store.dispatch(addNotification({
          type: 'error',
          content: {
            heading: 'Signup failed',
            message: error.message
          }
        }));
      }
    }
    // authManager.getSignInWithPopup()(auth, provider)
    //   .then(this.handleSuccess.bind(this))
    //   .catch(this.handleErrors.bind(this));
  }

  async loginFacebook(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    const auth = authManager.getAuth();
    auth.useDeviceLanguage();
    const provider = authManager.getAuthProvider("FacebookAuthProvider");
    provider.addScope('email');
    provider.addScope('public_profile');
    authManager.getSignInWithPopup()(auth, provider)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleErrors.bind(this));
  }

  async loginApple(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    const auth = authManager.getAuth();
    const provider = authManager.getAuthProvider("AppleAuthProvider");
    authManager.getSignInWithPopup()(auth, provider)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleErrors.bind(this));
  }

  async loginGoogle(e) {
    if (e.target.attributes.disabled) { return null; }
    e.preventDefault();
    const auth = authManager.getAuth();
    const provider = authManager.getAuthProvider("GoogleAuthProvider");
    authManager.getSignInWithPopup()(auth, provider)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleErrors.bind(this));
  }

  backToLogin(e) {
    e.preventDefault();
    this.loginDialog = 'login';
  }

  static styles = [
    super.styles,
    css`
      :host {
        --slds-c-input-text-color: var(--input-text-color);
      }
    .center-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin-top: -3rem;
      min-height: 32rem;
    }
    .login {
      display: flex;
    }
    .login[hidden] {
      display: none;
    }
    .login-options>span>button, .login-options>span {
      width: 100%;
      display: inline-block;
    }
    .login-options {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-left: 1px solid #ddd;
      padding: 1rem 2rem;
    }
    .login-form {
      padding: 20px;
    }
    button.slds-button[disabled] {
      cursor: not-allowed;
    }
    .dark .slds-button_neutral:disabled, .dark .slds-button_neutral[disabled] {
      background-color: #444444;
      border-color: #c9c9c9;
      color: #c9c9c9;
    }
    .dark .slds-button_neutral:disabled:hover, .dark .slds-button_neutral[disabled]:hover {
      color: #c9c9c9;
    }
    .dark label {
      color: white;
    }
    label.slds-form-element__label {
      color: var(--text-color);
    }
    .slds-input, .slds-input:active, .slds-input:focus {
      --slds-c-input-text-color: var(--input-text-color, #181818);
    }
    .slds-has-error .slds-input {
      --slds-c-input-text-color: var(--input-text-color, #181818);
    }
    .signup {
      min-width: 30rem;
    }
    `
  ];

  render() {
    return html`
    ${this.errorMsg===null ? '' : html`<div class="slds-notify slds-notify_alert slds-alert_error" role="alert">
      <span class="slds-assistive-text">error</span>
      <span class="slds-icon_container slds-icon-utility-error slds-m-right_x-small" title="Description of icon when needed">
        <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"></use>
        </svg>
      </span>
      <h2>${this.errorMsg.msg}
        ${this.errorMsg.code ? html`<a href="/error/${this.errorMsg.code}">More Information</a>` : ''}
      </h2>
      <div class="slds-notify__close">
        <button @click="${this.clearError}" class="slds-button slds-button_icon slds-button_icon-small slds-button_icon-inverse" title="Close">
          <svg class="slds-button__icon" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
          </svg>
          <span class="slds-assistive-text">Close</span>
        </button>
      </div>
    </div>`}
    <div class="center-container">
      <div ?hidden="${!(this.loginDialog === 'authenticated')}" class="login slds-box">
        <div class="slds-form-element">
          <p>The account is authenticated.</p>
        </div>
      </div>
      <div ?hidden="${!(this.loginDialog === 'accountType')}" class="login slds-box slds-m-top_xx-large slds-m-bottom_xx-large">
        <div class="slds-form-element slds-text-align_center">
          <fieldset class="slds-form-element slds-m-left_x-large slds-m-right_x-large">
            <legend class="slds-form-element__legend slds-form-element__label">Select a plan</legend>
            <div class="slds-form-element__control">
              <div class="slds-visual-picker slds-visual-picker_medium slds-m-right_medium">
                <input type="radio" id="visual-picker-370" value="visual-picker-370" name="example-unique-name-140" />
                <label for="visual-picker-370">
                  <span class="slds-visual-picker__figure slds-visual-picker__text slds-align_absolute-center">
                    <svg class="slds-icon slds-icon-standard-account slds-icon_large" aria-hidden="true">
                      <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#account"></use>
                    </svg>
                  </span>
                  <span class="slds-visual-picker__body">
                    <span class="slds-text-heading_small">Corporate Account</span>
                    <span class="slds-text-title">For business related activities</span>
                  </span>
                  <span class="slds-icon_container slds-visual-picker__text-check">
                    <svg class="slds-icon slds-icon-text-check slds-icon_x-small" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
                    </svg>
                  </span>
                </label>
              </div>
              <div class="slds-visual-picker slds-visual-picker_medium slds-m-left_medium">
                <input type="radio" id="visual-picker-371" value="visual-picker-371" name="example-unique-name-140" />
                <label for="visual-picker-371">
                  <span class="slds-visual-picker__figure slds-visual-picker__text slds-align_absolute-center">
                    <svg class="slds-icon slds-icon-standard-lead slds-icon_large" aria-hidden="true">
                      <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#lead"></use>
                    </svg>
                  </span>
                  <span class="slds-visual-picker__body">
                    <span class="slds-text-heading_small">Personal Account</span>
                    <span class="slds-text-title">For personal use</span>
                  </span>
                  <span class="slds-icon_container slds-visual-picker__text-check">
                    <svg class="slds-icon slds-icon-text-check slds-icon_x-small" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
                    </svg>
                  </span>
                </label>
              </div>
            </div>
          </fieldset>
          <button @click="${this.verifyMfa}" ?disabled="${this.smsVerificationCodeDisabled}" type="submit" class="slds-m-bottom_medium slds-button slds-button_brand  slds-m-top_x-small">Choose</button>
        </div>
      </div>
      <div ?hidden="${!(this.loginDialog === 'recaptcha')}" class="login slds-box">
        <div class="slds-grid slds-wrap">
          <div class="slds-col slds-size_1-of-1">
            <p>Please wait until we verify your browser, you may need to complete a captcha.</p>
          </div>
          <div class="slds-col slds-size_1-of-1">
            <slot></slot>
          </div>
        </div>
      </div>
      <div ?hidden="${!(this.loginDialog === 'signup')}" class="signup slds-box">
        <button class="slds-button slds-m-left_medium" @click="${this.backToLogin}">
          <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrow_left"></use>
          </svg>
          Back
        </button>
        <div class="slds-grid slds-wrap slds-p-around_medium">
          <div class="slds-col slds-size_1-of-1">
            <form @submit="${this.signupEmail}">
              <div class="slds-form">
                <div class="slds-form-element slds-form-element_horizontal">
                  <label class="slds-form-element__label" for="display-name">Display Name</label>
                  <div class="slds-form-element__control">
                    <input type="text" id="display-name" class="slds-input" placeholder="Enter display name" required>
                  </div>
                </div>
                <div class="slds-form-element slds-form-element_horizontal">
                  <label class="slds-form-element__label" for="signup-email">Email</label>
                  <div class="slds-form-element__control">
                    <input type="email" id="signup-email" class="slds-input" placeholder="Enter email" required>
                  </div>
                </div>
                <div class="slds-form-element slds-form-element_horizontal ${this.errorMsg && this.errorMsg.type === 'password-mismatch' ? 'slds-has-error' : ''}">
                  <label class="slds-form-element__label" for="signup-password">Password</label>
                  <div class="slds-form-element__control">
                    <input type="password" id="signup-password" class="slds-input" placeholder="Enter password" required>
                  </div>
                </div>
                <div class="slds-form-element slds-form-element_horizontal ${this.errorMsg && this.errorMsg.type === 'password-mismatch' ? 'slds-has-error' : ''}">
                  <label class="slds-form-element__label" for="confirm-password">Confirm Password</label>
                  <div class="slds-form-element__control">
                    <input type="password" id="confirm-password" class="slds-input" placeholder="Confirm password" required>
                  </div>
                </div>
                <button ?disabled="${this.signupDisabled}" type="submit" class="slds-button slds-button_brand slds-m-top_medium slds-size_1-of-1">Sign Up</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div ?hidden="${!(this.loginDialog === 'login')}" class="login slds-box">
        <div class="login-form">
          <form @submit="${this.loginEmailForm}">
            <div class="slds-form-element">
              <label class="slds-form-element__label" for="email">Email</label>
              <div class="slds-form-element__control">
                <input type="text" id="email" class="slds-input" placeholder="Email" @input="${this.updateEmail}" required>
              </div>
            </div>
            <div class="slds-form-element">
              <label class="slds-form-element__label" for="password">Password</label>
              <div class="slds-form-element__control">
                <input type="password" id="password" class="slds-input" placeholder="Password" @input="${this.updatePassword}" required>
              </div>
            </div>
            <button type="submit" class="slds-button slds-button_brand slds-m-top_x-small" ?disabled="${this.loginDisabled}">Submit</button>
          </form>
        </div>
        <div class="login-options">
          <span>
            <button @click="${this.loginFacebook}" class="slds-button slds-button_neutral">
              Login with Meta
            </button>
          </span>
          <span>
            <button @click="${this.loginGoogle}" class="slds-button slds-button_neutral">
              Login with Google
            </button>
          </span>
          <span>
            <button @click="${this.loginApple}" class="slds-button slds-button_neutral">
              Login with Apple
            </button>
          </span>
          <span>
            <button @click="${this.loginEmail}" class="slds-button slds-button_neutral">
              Email / Password
            </button>
          </span>
        </div>
      </div>
    </div>
    `
  }
}